import getAll from 'utils/getAll'
import { apiUrls, roles } from 'consts'
import ActionButtons from 'shared/components/ActionButtons'

interface getRowsProps {
  setDeleteEntryId: Function
  setShowModal: Function
}

const getRows = async (props: getRowsProps) => {
  let data = await getAll(apiUrls.administrators)

  data.forEach((row: any, index: number, dataArray: any) => {
    dataArray[index].action = (
      <ActionButtons
        buttons={[
          {
            type: 'u',
            url: '/edit-administrator/' + row.id,
          },
          {
            type: 'p',
            id: dataArray[index].id,
            url: '/change-administrator-password/' + row.id,
          },
          {
            type: 'd',
            id: dataArray[index].id,
            url: '/delete-administrator/' + row.id,
            setDeleteEntryId: props.setDeleteEntryId,
            setShowModal: props.setShowModal,
          },
        ]}
      />
    )
  })

  return data
}

export default getRows
